import React from "react";

export const Box = ({className, title, tools, children}) => {
    return (
        <div className={`box ${className ?? ''}`}>
            {(title || tools) &&
                <div className="header">
                    <span>{title}</span>
                    {tools}
                </div>
            }
            <div className="body">
                {children}
            </div>
        </div>
    );
}

export default Box;